// Was a stub that hardcoded isAuthenticated: true. Now backed by the real
// Firebase session, so the views that guard on it actually guard. Kept as a
// default export at this path so those views need no change.
import { useAuth as useAuthContext } from "@/context/AuthContext";

const useAuth = () => useAuthContext();

export default useAuth;
